// components/tasks/TaskGroup.js
import React from 'react';
import TaskItem from './TaskItem.js';

const TaskGroup = ({ groupName, groupConfig, tasks, onTaskToggle, pendingChanges, isAdmin }) => {
  const getDisabled = (task) => {
    if (!isAdmin) return true;
    if (task.state.checked) return !task.canUncomplete;
    return !task.canComplete;
  };

  return (
    <div className="ta-section">
      <div className="ta-section-title">
        {groupName}
        {groupConfig.note && <span className="note"> · {groupConfig.note}</span>}
      </div>
      <div>
        {tasks.map(task => (
          <TaskItem
            key={task.id}
            task={task}
            onToggle={onTaskToggle}
            disabled={getDisabled(task)}
            hasChange={pendingChanges.has(task.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskGroup;
